"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploaderSource = void 0;
var zod_1 = require("zod");
var UploaderSource;
(function (UploaderSource) {
    UploaderSource.Schema = zod_1.z.enum(["worker", "customer", "staff"]);
})(UploaderSource || (UploaderSource = {}));
exports.UploaderSource = UploaderSource;
